// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608281627/js/" + chunkId + "." + {"44":"012b53b5","225":"56b8919e","481":"3f60fe44","486":"99787929","770":"a87a48e2"}[chunkId] + ".0.4179605897610451.chunk.js";
};